import { makeStyles, Box, Typography } from "@material-ui/core";
import * as React from "react";

import OfferAchievement from "../icon/OfferAchievement";
import OfferAdviceAndFollowup from "../icon/OfferAdviceAndFollowup";
import OfferPartners from "../icon/OfferPartners";
import OfferStrengthOfPartnerFinancialInstitutions from "../icon/OfferStrengthOfPartnerFinancialInstitutions";
import OfferStrengthOfPropertiesForSale from "../icon/OfferStrengthOfPropertiesForSale";
import { LinkifiedText } from "../LinkifiedText";

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 16,
  },
}));

interface props {
  title:
    | "会社の実績"
    | "販売物件/物件買取の強み"
    | "提携金融機関"
    | "販売後の物件管理"
    | "自社ならではのアピールポイント";
  content: string;
}

export const OfferDetailContent: React.FC<props> = ({ title, content }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box mb={1 / 2} display="flex" flexDirection="row" alignItems="center">
        <Box mr={1 / 2}>
          {(() => {
            switch (title) {
              case "会社の実績":
                return <OfferAchievement />;
              case "販売物件/物件買取の強み":
                return <OfferStrengthOfPropertiesForSale />;
              case "提携金融機関":
                return <OfferStrengthOfPartnerFinancialInstitutions />;
              case "販売後の物件管理":
                return <OfferPartners />;
              case "自社ならではのアピールポイント":
                return <OfferAdviceAndFollowup />;
              default:
                return null;
            }
          })()}
        </Box>
        {/* icon */}
        <Typography variant="h5" color="primary">
          {title}
        </Typography>
      </Box>
      <Typography variant="body1" color="textPrimary">
        <LinkifiedText text={content} />
      </Typography>
    </Box>
  );
};
